import {
  JupiterTheme,
  BetaRibbon,
  HeadBarConfig,
} from '@jupiterone/jupiter-web-toolkit';
import clsx from 'clsx';
import React from 'react';
import { Lock } from 'react-feather';
import { Link } from 'react-router-dom';
import { gridStyles, iconStyles } from './AppsMenu.styles';

import { createStyles, makeStyles } from '@material-ui/styles';

interface AppsMenuItemProps {
  app: HeadBarConfig;
  locked?: boolean;
  onClick: () => void;
}

const useStyles = makeStyles((theme: JupiterTheme) => {
  return createStyles({
    betaRibbon: {
      position: 'absolute',
      top: theme.spacing(2),
      right: theme.spacing(2),
    },

    learnMore: {
      position: 'absolute',
      fontSize: 12,
      bottom: 0,
      color: theme.palette.blue[800],
      padding: theme.spacing(0.5),
      borderRadius: '50%',
    },
    appNameGroup: {
      display: 'flex',
      justifyContent: 'center',
      lineHeight: 1.2,
      padding: '0 12px 5.5px',
      color: theme.palette.navy[400],
      flex: '0 0 auto',
      fontWeight: 900,
      letterSpacing: -0.25,
      textAlign: 'center',
      whiteSpace: 'nowrap',
      position: 'relative',
      bottom: -30,
    },
    appName: {
      borderRadius: 16,
      color: theme.palette.text.dark,
      padding: '3px 16px 5px',
    },
    locked: {
      color: theme.palette.coolGrey[400],
      stroke: theme.palette.coolGrey[400],
    },
  });
});

const AppsMenuItem = ({ app, locked = false, onClick }: AppsMenuItemProps) => {
  const gridClasses = gridStyles();
  const iconClasses = iconStyles();
  const classes = useStyles();
  const handleClick = () => !locked && onClick();

  return (
    <Link
      className={!locked ? gridClasses.gridCell : gridClasses.gridCellNoHover}
      to={!locked ? app.url : '#'}
      onClick={handleClick}
    >
      {locked && <Lock className={iconClasses.lockIcon} />}
      <div className={clsx(iconClasses.bgIconGroup, locked && classes.locked)}>
        <app.icon
          className={clsx(iconClasses.bgIcon, locked && classes.locked)}
        />
      </div>
      <div className={classes.appNameGroup}>
        <span className={clsx(classes.appName, locked && classes.locked)}>
          {app.name}
        </span>
      </div>
      {app.beta && <BetaRibbon classes={classes.betaRibbon} />}
      {locked && <div className={classes.learnMore}>Learn More</div>}
    </Link>
  );
};

export default AppsMenuItem;
